import backupsStoredReducer from "./backupsStoredReducer.slice";

export default backupsStoredReducer;
